module.exports = __webpack_public_path__ + "img/no-access.cc2f225f.svg";